import { formatRelativeTime } from "../../../utils/siataWeatherFormatting";

const WeatherRiskSourceStatus = ({ sourceHealth, risk, evidence }) => {
  if (!sourceHealth && !risk) {
    return null;
  }

  const radarSource = risk?.radarSourceKey || sourceHealth?.activeRadarSourceKey;
  const precipSource = risk?.precipitationSourceKey || sourceHealth?.precipitationSourceKey;
  const fallbackActive = risk?.fallbackActive ?? sourceHealth?.fallbackActive;
  const satellite = evidence?.satellite;

  return (
    <section className="weather-risk-source-status">
      <h4>Source freshness</h4>
      <dl className="weather-risk-source-status__grid">
        <div>
          <dt>Active radar</dt>
          <dd>
            {fallbackActive
              ? "RainViewer fallback (IDEAM unavailable or stale)"
              : radarSource || "—"}
          </dd>
        </div>
        <div>
          <dt>Precipitation source</dt>
          <dd>{precipSource || radarSource || "—"}</dd>
        </div>
        <div>
          <dt>Radar freshness</dt>
          <dd>{risk?.radarFreshnessStatus || sourceHealth?.radarFreshnessStatus || "unknown"}</dd>
        </div>
        <div>
          <dt>Latest radar frame</dt>
          <dd>
            {risk?.radarFrameTime || sourceHealth?.radarFrameTime
              ? formatRelativeTime(risk?.radarFrameTime || sourceHealth?.radarFrameTime)
              : "—"}
          </dd>
        </div>
        <div>
          <dt>Fallback</dt>
          <dd>{fallbackActive ? "Active (RainViewer backup)" : "Not active"}</dd>
        </div>
        <div>
          <dt>SIATA observations</dt>
          <dd>
            {sourceHealth?.latestSiataObservationAt
              ? formatRelativeTime(sourceHealth.latestSiataObservationAt)
              : sourceHealth?.siataFreshnessStatus || "unknown"}
          </dd>
        </div>
        <div>
          <dt>Latest alert</dt>
          <dd>
            {sourceHealth?.latestAlertAt
              ? formatRelativeTime(sourceHealth.latestAlertAt)
              : "—"}
          </dd>
        </div>
        <div>
          <dt>Satellite estimate</dt>
          <dd>
            {satellite?.available || risk?.satelliteActive
              ? `${satellite?.healthStatus || "available"} · not radar`
              : satellite?.suggested || risk?.satelliteSuggested
                ? "Suggested (supplemental)"
                : "Not active"}
          </dd>
        </div>
        <div>
          <dt>Source quality</dt>
          <dd>{sourceHealth?.sourceQuality || risk?.sourceQuality || "—"}</dd>
        </div>
      </dl>

      {sourceHealth?.warnings?.length ? (
        <ul className="weather-risk-source-status__warnings">
          {sourceHealth.warnings.map((warning) => (
            <li key={warning}>{warning}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
};

export default WeatherRiskSourceStatus;
